import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import NutriScoreSelect from 'components/desktop/_general/NutriScoreSelect/NutriScoreSelect';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

export const IngredientNutriScoreCard = ({ state, handlers }: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const isIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEINGREDIENT,
	]);

	return (
		<FoldableCard
			disabled={!isIngredientEditor}
			dataComponentType="ingredient-nutriscore-card"
			defaultOpen={true}
			hasLock={true}
			defaultLocked={
				!(state.nutriScoreCategoryIsSetByUser === null
					? true
					: state.nutriScoreCategoryIsSetByUser)
			}
			handleLockClick={handlers.setNutriScoreCategoryIsSetByUser}
			title={t('_general:NUTRI_SCORE')}
			content={
				<NutriScoreSelect
					hasNutriScore={state.hasNutriScore ?? false}
					nutriScoreCategory={state.nutriScoreCategory}
					setHasNutriScore={handlers.setHasNutriScore}
					setNutriScoreCategory={handlers.setNutriScoreCategory}
					canImplyNutriScoreMethod={true}
					disabled={!isIngredientEditor}
				></NutriScoreSelect>
			}
		/>
	);
};
